module.exports = __webpack_public_path__ + "static/media/microsoft_login_icon.23b24e03.svg";